/** THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY MANUALLY. */

import get from "lodash/get";

import { type IconProps } from "./Icon.props";
import AccountCredit from "./AccountCredit/AccountCredit.web";
import ActivateBarcodes from "./ActivateBarcodes/ActivateBarcodes.web";
import Activity from "./Activity/Activity.web";
import AffirmLogo from "./AffirmLogo/AffirmLogo.web";
import AmexLogo from "./AmexLogo/AmexLogo.web";
import ArrowRightCircle from "./ArrowRightCircle/ArrowRightCircle.web";
import ArrowRightSquare from "./ArrowRightSquare/ArrowRightSquare.web";
import At from "./At/At.web";
import Bag from "./Bag/Bag.web";
import Barcode from "./Barcode/Barcode.web";
import BasicStar from "./BasicStar/BasicStar.web";
import Calendar from "./Calendar/Calendar.web";
import Call from "./Call/Call.web";
import CampaignMonitor from "./CampaignMonitor/CampaignMonitor.web";
import Cart from "./Cart/Cart.web";
import Category from "./Category/Category.web";
import Chart from "./Chart/Chart.web";
import Chart2 from "./Chart2/Chart2.web";
import Check from "./Check/Check.web";
import Checkmark from "./Checkmark/Checkmark.web";
import Chevron from "./Chevron/Chevron.web";
import ChevronDown from "./ChevronDown/ChevronDown.web";
import ChevronLeft from "./ChevronLeft/ChevronLeft.web";
import ChevronLeftRounded from "./ChevronLeftRounded/ChevronLeftRounded.web";
import ChevronRight from "./ChevronRight/ChevronRight.web";
import ChevronRightRounded from "./ChevronRightRounded/ChevronRightRounded.web";
import ChevronUp from "./ChevronUp/ChevronUp.web";
import Circle from "./Circle/Circle.web";
import Clock from "./Clock/Clock.web";
import Copy from "./Copy/Copy.web";
import DangerCircle from "./DangerCircle/DangerCircle.web";
import DangerTriangle from "./DangerTriangle/DangerTriangle.web";
import Dashboard from "./Dashboard/Dashboard.web";
import DinersLogo from "./DinersLogo/DinersLogo.web";
import Discount from "./Discount/Discount.web";
import DiscoverLogo from "./DiscoverLogo/DiscoverLogo.web";
import Document from "./Document/Document.web";
import DollarCircle from "./DollarCircle/DollarCircle.web";
import DollarFilled from "./DollarFilled/DollarFilled.web";
import Download from "./Download/Download.web";
import Edit from "./Edit/Edit.web";
import EllipsisHorizontal from "./EllipsisHorizontal/EllipsisHorizontal.web";
import Envelope from "./Envelope/Envelope.web";
import Error from "./Error/Error.web";
import Exchange from "./Exchange/Exchange.web";
import FacebookLogo from "./FacebookLogo/FacebookLogo.web";
import FavoriteHeart from "./FavoriteHeart/FavoriteHeart.web";
import Filter from "./Filter/Filter.web";
import FourPointStar from "./FourPointStar/FourPointStar.web";
import Fulfillment from "./Fulfillment/Fulfillment.web";
import Gift from "./Gift/Gift.web";
import Google from "./Google/Google.web";
import Graph from "./Graph/Graph.web";
import Heart from "./Heart/Heart.web";
import Hide from "./Hide/Hide.web";
import Home from "./Home/Home.web";
import Image from "./Image/Image.web";
import Info from "./Info/Info.web";
import InstagramLogo from "./InstagramLogo/InstagramLogo.web";
import JCBLogo from "./JCBLogo/JCBLogo.web";
import LeavePage from "./LeavePage/LeavePage.web";
import LightningBolt from "./LightningBolt/LightningBolt.web";
import Link from "./Link/Link.web";
import LinkedInLogo from "./LinkedInLogo/LinkedInLogo.web";
import List from "./List/List.web";
import Location from "./Location/Location.web";
import Lock from "./Lock/Lock.web";
import Login from "./Login/Login.web";
import MagicWand from "./MagicWand/MagicWand.web";
import MagnifyingGlass from "./MagnifyingGlass/MagnifyingGlass.web";
import MastercardLogo from "./MastercardLogo/MastercardLogo.web";
import MeatballHorizontal from "./MeatballHorizontal/MeatballHorizontal.web";
import Membership from "./Membership/Membership.web";
import MenuClosed from "./MenuClosed/MenuClosed.web";
import MenuOpen from "./MenuOpen/MenuOpen.web";
import Message from "./Message/Message.web";
import Minus from "./Minus/Minus.web";
import MoreCircle from "./MoreCircle/MoreCircle.web";
import Move from "./Move/Move.web";
import Orders from "./Orders/Orders.web";
import Override from "./Override/Override.web";
import Paper from "./Paper/Paper.web";
import PaperPlus from "./PaperPlus/PaperPlus.web";
import PaperUpload from "./PaperUpload/PaperUpload.web";
import Pin from "./Pin/Pin.web";
import Placeholder from "./Placeholder/Placeholder.web";
import Plus from "./Plus/Plus.web";
import PlusSquare from "./PlusSquare/PlusSquare.web";
import Printer from "./Printer/Printer.web";
import QRPlaceholder from "./QRPlaceholder/QRPlaceholder.web";
import Renewal from "./Renewal/Renewal.web";
import Resell from "./Resell/Resell.web";
import Reseller from "./Reseller/Reseller.web";
import Return from "./Return/Return.web";
import RotateRight from "./RotateRight/RotateRight.web";
import RoundedChevron from "./RoundedChevron/RoundedChevron.web";
import Scan from "./Scan/Scan.web";
import Send from "./Send/Send.web";
import Shield from "./Shield/Shield.web";
import Show from "./Show/Show.web";
import Speech from "./Speech/Speech.web";
import Split from "./Split/Split.web";
import SquareLogo from "./SquareLogo/SquareLogo.web";
import Star from "./Star/Star.web";
import Tag from "./Tag/Tag.web";
import TickCircle from "./TickCircle/TickCircle.web";
import TickShieldCircle from "./TickShieldCircle/TickShieldCircle.web";
import TickSquare from "./TickSquare/TickSquare.web";
import Ticket from "./Ticket/Ticket.web";
import TicketStar from "./TicketStar/TicketStar.web";
import Trash from "./Trash/Trash.web";
import TwoUsers from "./TwoUsers/TwoUsers.web";
import UnionPayLogo from "./UnionPayLogo/UnionPayLogo.web";
import Unlock from "./Unlock/Unlock.web";
import Upload from "./Upload/Upload.web";
import User from "./User/User.web";
import UserAdd from "./UserAdd/UserAdd.web";
import UserGroup from "./UserGroup/UserGroup.web";
import VisaLogo from "./VisaLogo/VisaLogo.web";
import Waitlist from "./Waitlist/Waitlist.web";
import Wallet from "./Wallet/Wallet.web";
import Warning from "./Warning/Warning.web";
import Website from "./Website/Website.web";
import Wheelchair from "./Wheelchair/Wheelchair.web";
import X from "./X/X.web";
import XCircle from "./X/XCircle.web";
import XLogo from "./XLogo/XLogo.web";

/**
 * Usage
 * ---
 * You can use these icons in one of several ways:
 * <Icon name="Checkmark" />
 * <Icon.Checkmark />
 * <Icon.Checkmark outline />
 * <Icon.Checkmark.Outline />
 */
export default function Icon({
  name = undefined,
  outline = false,
  colorPalette = "currentColor",
  primary = undefined,
  secondary = undefined,
  sx,
  css,
  boxSize,
  w,
  h,
  ...props
}: IconProps): JSX.Element {
  if (!name) {
    // eslint-disable-next-line no-console
    console.error("Icon name is required");
    return <></>;
  }

  const Component = get(Icon, name);

  // Only apply default size if no sizing props are provided
  const hasCustomSize =
    boxSize !== undefined || w !== undefined || h !== undefined;
  const sizeProps = hasCustomSize
    ? { boxSize, w, h }
    : { w: "element.xl", h: "element.xl" };

  return (
    <Component
      name={name}
      outline={outline}
      colorPalette={colorPalette}
      primary={primary}
      secondary={secondary}
      css={sx && css ? ([css, sx] as unknown as IconProps["css"]) : sx ?? css}
      {...sizeProps}
      {...props}
    />
  );
}

export type IconComponentKeys = Exclude<keyof typeof Icon, "default">;

Icon.AccountCredit = AccountCredit;
Icon.ActivateBarcodes = ActivateBarcodes;
Icon.Activity = Activity;
Icon.AffirmLogo = AffirmLogo;
Icon.AmexLogo = AmexLogo;
Icon.ArrowRightCircle = ArrowRightCircle;
Icon.ArrowRightSquare = ArrowRightSquare;
Icon.At = At;
Icon.Bag = Bag;
Icon.Barcode = Barcode;
Icon.BasicStar = BasicStar;
Icon.Calendar = Calendar;
Icon.Call = Call;
Icon.CampaignMonitor = CampaignMonitor;
Icon.Cart = Cart;
Icon.Category = Category;
Icon.Chart = Chart;
Icon.Chart2 = Chart2;
Icon.Check = Check;
Icon.Checkmark = Checkmark;
Icon.Chevron = Chevron;
Icon.ChevronDown = ChevronDown;
Icon.ChevronLeft = ChevronLeft;
Icon.ChevronLeftRounded = ChevronLeftRounded;
Icon.ChevronRight = ChevronRight;
Icon.ChevronRightRounded = ChevronRightRounded;
Icon.ChevronUp = ChevronUp;
Icon.Circle = Circle;
Icon.Clock = Clock;
Icon.Copy = Copy;
Icon.DangerCircle = DangerCircle;
Icon.DangerTriangle = DangerTriangle;
Icon.Dashboard = Dashboard;
Icon.DinersLogo = DinersLogo;
Icon.Discount = Discount;
Icon.DiscoverLogo = DiscoverLogo;
Icon.Document = Document;
Icon.DollarCircle = DollarCircle;
Icon.DollarFilled = DollarFilled;
Icon.Download = Download;
Icon.Edit = Edit;
Icon.EllipsisHorizontal = EllipsisHorizontal;
Icon.Envelope = Envelope;
Icon.Error = Error;
Icon.Exchange = Exchange;
Icon.FacebookLogo = FacebookLogo;
Icon.FavoriteHeart = FavoriteHeart;
Icon.Filter = Filter;
Icon.FourPointStar = FourPointStar;
Icon.Fulfillment = Fulfillment;
Icon.Gift = Gift;
Icon.Google = Google;
Icon.Graph = Graph;
Icon.Heart = Heart;
Icon.Hide = Hide;
Icon.Home = Home;
Icon.Image = Image;
Icon.Info = Info;
Icon.InstagramLogo = InstagramLogo;
Icon.JCBLogo = JCBLogo;
Icon.LeavePage = LeavePage;
Icon.LightningBolt = LightningBolt;
Icon.Link = Link;
Icon.LinkedInLogo = LinkedInLogo;
Icon.List = List;
Icon.Location = Location;
Icon.Lock = Lock;
Icon.Login = Login;
Icon.MagicWand = MagicWand;
Icon.MagnifyingGlass = MagnifyingGlass;
Icon.MastercardLogo = MastercardLogo;
Icon.MeatballHorizontal = MeatballHorizontal;
Icon.Membership = Membership;
Icon.MenuClosed = MenuClosed;
Icon.MenuOpen = MenuOpen;
Icon.Message = Message;
Icon.Minus = Minus;
Icon.MoreCircle = MoreCircle;
Icon.Move = Move;
Icon.Orders = Orders;
Icon.Override = Override;
Icon.Paper = Paper;
Icon.PaperPlus = PaperPlus;
Icon.PaperUpload = PaperUpload;
Icon.Pin = Pin;
Icon.Placeholder = Placeholder;
Icon.Plus = Plus;
Icon.PlusSquare = PlusSquare;
Icon.Printer = Printer;
Icon.QRPlaceholder = QRPlaceholder;
Icon.Renewal = Renewal;
Icon.Resell = Resell;
Icon.Reseller = Reseller;
Icon.Return = Return;
Icon.RotateRight = RotateRight;
Icon.RoundedChevron = RoundedChevron;
Icon.Scan = Scan;
Icon.Send = Send;
Icon.Shield = Shield;
Icon.Show = Show;
Icon.Speech = Speech;
Icon.Split = Split;
Icon.SquareLogo = SquareLogo;
Icon.Star = Star;
Icon.Tag = Tag;
Icon.TickCircle = TickCircle;
Icon.TickShieldCircle = TickShieldCircle;
Icon.TickSquare = TickSquare;
Icon.Ticket = Ticket;
Icon.TicketStar = TicketStar;
Icon.Trash = Trash;
Icon.TwoUsers = TwoUsers;
Icon.UnionPayLogo = UnionPayLogo;
Icon.Unlock = Unlock;
Icon.Upload = Upload;
Icon.User = User;
Icon.UserAdd = UserAdd;
Icon.UserGroup = UserGroup;
Icon.VisaLogo = VisaLogo;
Icon.Waitlist = Waitlist;
Icon.Wallet = Wallet;
Icon.Warning = Warning;
Icon.Website = Website;
Icon.Wheelchair = Wheelchair;
Icon.X = X;
Icon.XCircle = XCircle;
Icon.XLogo = XLogo;
